import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { connect } from 'react-redux'
import { useParams, useHistory, Link } from "react-router-dom";
import { setLoading, setSnackInfo } from '../redux/actions/appAction';
import Divider from '@material-ui/core/Divider';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { ROLENAME, saleLostApprovalHeader, designLostApprovalHeader } from '../utils';
import moment from 'moment';
import Dialog from '@material-ui/core/Dialog';
import { Modal, Tooltip } from 'antd';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import HttpService from '../services/httpService';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import Checkbox from '@material-ui/core/Checkbox';
import { commaSeparateAmount } from './commaSeparate';
import { DownloadOutlined, EyeFilled } from '@ant-design/icons';
import Autocomplete from '@material-ui/lab/Autocomplete';
import InfoIcon from '@material-ui/icons/Info';
import TablePagination from '@material-ui/core/TablePagination';
import { sentForApproval } from '../utils';

const useStyles = makeStyles((theme) => ({
    table: {
        width: '80vw',
        textAlign: 'center'
    },
    root: {
        width: '100%',
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
}));


const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#ccc",
        color: theme.palette.common.black,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);

function LostLeadApprovalView(props) {
    const classes = useStyles()
    const { userDetails } = useSelector(state => state.user);
    const [loader, setLoader] = useState(true);
    const history = useHistory();
    const [lostApprovalLeads, setLostApprovalLeads] = useState([]);
    const [remarks, setRemarks] = useState('');
    const [openDialogapprove, setOpenDialogapprove] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [rowLeadId, setRowLeadId] = useState('');
    const [isFileUploaded, setIsFileUploaded] = useState(false);
    const [lostAttachmentFile, setLostAttachmentFile] = useState('');
    const [isChecked,setIsChecked] = useState(false);
    const [asmApproval, setAsmApproval] = useState('');
    const [commonExpCenter, setExpCenter] = useState([])
    const [selectedExperienceCenter, setSelectedExperienceCenter] = useState([])
    const [row,setRow] = useState()
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [total, setTotal] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);

    const isSentForApproval = (val) => (val || '').toLowerCase() === 'sent for approval';

    useEffect(() => {
        getAllApprovedLeads();
        expCenters();
    }, [])

    const getAllApprovedLeads = async (selectedExpCenter, page = 1, limit) => {
    props.setLoading(true);
    try {
        const pageLimit = limit || rowsPerPage;
        const response = await HttpService.getLostLeadRequests(page, pageLimit, selectedExpCenter);
        const { data, total, totalPages } = response.data;
        
        setTotal(total);
        setTotalPages(totalPages);
        setCurrentPage(page);

        if (!data || data.length === 0) {
            setLostApprovalLeads([]);
        } else {
            arrayUpdateFunction(data, selectedExpCenter);
        }
    } catch (error) {
        props.setSnackInfo(error?.response?.data ?? "Something went wrong", "error");
    } finally {
        props.setLoading(false);
        setLoader(false);
    }
    };

    //  Show Data according experience and role
    const arrayUpdateFunction = (data, selectedExpCenter) => {
    if (selectedExpCenter?.length > 0) {
        const expCenterIds = selectedExpCenter.map(el => el._id);
        setLostApprovalLeads(data.filter(row => expCenterIds.includes(row?.experienceCenterId)));
    } else {
        setLostApprovalLeads(data);
    }
    };
    
    const handleApprove = async (v) => {
        props.setLoading(true);
        try {
            setRow(v);
            setRowLeadId(v?._id);
            setOpenDialogapprove(true);
            setAsmApproval(v?.salesLostApproval?.asmApproval)
        } catch (error) {
            console.log("error", error);
        }
        props.setLoading(false);
    }
    const handleReject = async (v) => {
        setRowLeadId(v?._id);
        setOpenDialog(true);
    }

    const handleMultipleExpData = (event, newValue) => {
        setSelectedExperienceCenter(newValue)
        getAllApprovedLeads(newValue)
    }

   const getApprovalState = (row, roleKey) => {
        const salesKeyMap = {
            asm: 'asmApproval',
            sm: 'smApproval',
            dgm: 'dgmSalesApproval',
            ch: 'centerHeadApproval'
        };

        const designKeyMap = {
            odm: 'odmApproval',
            dgmDesign: 'dgmDesignApproval',
            admin: 'adminApproval'
        };

        // Check if it's a sales role
        if (salesKeyMap[roleKey]) {
            const field = salesKeyMap[roleKey];
            
            // First check unified approval structure on Lead
            if (row?.unifiedLostRefundApproval?.sales?.[field]) {
                return row.unifiedLostRefundApproval.sales[field];
            }

            // Then check legacy approval structure on Lead
            if (row?.salesLostApproval?.[field]) {
                return row.salesLostApproval[field];
            }

            // Fallback: unified approvals coming from AllApprovals enrichment
            if (row?.approvals?.unifiedLostRefundApproval?.sales?.[field]) {
                return row.approvals.unifiedLostRefundApproval.sales[field];
            }

            // Final fallback: legacy approvals coming from AllApprovals enrichment
            if (row?.approvals?.salesLostApproval?.[field]) {
                return row.approvals.salesLostApproval[field];
            }
        }

        // Check if it's a design role
        if (designKeyMap[roleKey]) {
            const field = designKeyMap[roleKey];
            
            // First check unified approval structure on Lead
            if (row?.unifiedLostRefundApproval?.design?.[field]) {
                return row.unifiedLostRefundApproval.design[field];
            }

            // Then check legacy approval structure on Lead
            if (row?.designLostApproval?.[field]) {
                return row.designLostApproval[field];
            }

            // Fallback: unified approvals coming from AllApprovals enrichment
            if (row?.approvals?.unifiedLostRefundApproval?.design?.[field]) {
                return row.approvals.unifiedLostRefundApproval.design[field];
            }

            // Final fallback: legacy approvals coming from AllApprovals enrichment
            if (row?.approvals?.designLostApproval?.[field]) {
                return row.approvals.designLostApproval[field];
            }
        }

        return '';
    };

    const canUserAct = (row) => {
        // Check each user role independently to see if they have a pending approval in their domain
        
        // Sales roles - check sales approvals
        if (userDetails?.roles?.find(role => role.name === ROLENAME.AssistantSalesManager)) {
            if (isSentForApproval(getApprovalState(row, 'asm'))) {
                return true;
            }
        }
        if (userDetails?.roles?.find(role => role.name === ROLENAME.SalesManager)) {
            if (isSentForApproval(getApprovalState(row, 'sm'))) {
                return true;
            }
        }
        if (userDetails?.roles?.find(role => role.name === ROLENAME.DGM_Sales) || userDetails?.roles?.find(role => role.name === ROLENAME.AGMSales)) {
            if (isSentForApproval(getApprovalState(row, 'dgm'))) {
                return true;
            }
        }
        if (userDetails?.roles?.find(role => role.name === ROLENAME.CenterHead)) {
            if (isSentForApproval(getApprovalState(row, 'ch'))) {
                return true;
            }
        }
        
        // Design roles - check design approvals
        if (userDetails?.roles?.find(role => role.name === ROLENAME.OperationDesignManager)) {
            if (isSentForApproval(getApprovalState(row, 'odm'))) {
                return true;
            }
        }
        if (userDetails?.roles?.find(role => role.name === ROLENAME.DGM_Design) || userDetails?.roles?.find(role => role.name === ROLENAME.AGM_Design)) {
            if (isSentForApproval(getApprovalState(row, 'dgmDesign'))) {
                return true;
            }
        }
        if (userDetails?.roles?.find(role => role.name === ROLENAME.Admin)) {
            if (isSentForApproval(getApprovalState(row, 'admin'))) {
                return true;
            }
        }
        
        return false;
    };

    // Handle Approve Button of Lost
    const handleApproveWithRemarks = async (row, status) => {
        // let projectId = rowLeadId
        props.setLoading(true);
        try {
            let obj = {
                projectId : rowLeadId,
                status : status,
                remarks : remarks,
                asmLostAttachment: lostAttachmentFile
            }
            if(row?.raiseRefundLostSent){
                await HttpService.approveRefundLeadLostStatus(obj,rowLeadId);
            } else {
                await HttpService.approveLostLead(obj);
            } 
            props.setSnackInfo("Lost Approval Approved","success");
            setOpenDialogapprove(false);
            getAllApprovedLeads();
            setIsChecked(false);
            setRemarks('');
            setLostAttachmentFile('');
            setIsFileUploaded(false);
        } catch (error) {
            console.log("error", error);
        }
        props.setLoading(false);
    }

    const expCenters = async () => {
        props.setLoading(true);
        try {
            let response = await HttpService.getExpericenCenters();
            const matchedUsers = response.data.filter(user => {
                return userDetails.experienceCenterId.includes(user._id);
            });
            setExpCenter(matchedUsers)
        } catch (error) {
            console.error("Error fetching experience centers:", error);
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false);
    }
    // Handle reject Button of Lost
    const handleRejectWithRemarks = async (row, status) => {
        props.setLoading(true);
        try {
            const obj = {
                projectId: rowLeadId,
                status: status,
                remarks: remarks,
            }
            if(row?.raiseRefundLostSent){
                await HttpService.approveRefundLeadLostStatus(obj,rowLeadId);
            } else {
                await HttpService.approveLostLead(obj);
            }       
            props.setSnackInfo("Lost Request Rejected","success");
            setOpenDialog(false);
            getAllApprovedLeads();
        } catch (error) {
            console.log("error", error);
        }
        props.setLoading(false);
    }

    const handleCloseDialog = () => {
        setOpenDialog(false);
    }
    const handleCloseDialogApprove = () => {
        setOpenDialogapprove(false);
    }

    const handleRemarksChange = (event) => {
        setRemarks(event.target.value);
    }

    const handleUploadFile = async(e)=>{
        props.setLoading(true)
        try{
            const fd = new FormData();
            fd.append('file', e.target.files[0]);
            const res = await HttpService.uploadFile(fd);
            setLostAttachmentFile(res.data);
            setIsFileUploaded(true);
        }
        catch(err){
            props.setSnackInfo("Something went wrong","error");
        }
        props.setLoading(false);
    }

    return (
        <div>
            <div style={{ marginBottom: 20 }}>
                <h3 style={{ textAlign: 'center' }}>
                    {/* For Shomil role = Center Head */}
                    {userDetails.roles.find(role => role.name === ROLENAME.CenterHead || role.name === ROLENAME.SalesManager || role.name === ROLENAME.DGM_Sales || role.name === ROLENAME.AGMSales) && saleLostApprovalHeader} 
                    {/* For DK role for Admin */}
                    {userDetails.roles.find(role => role.name === ROLENAME.Admin || role.name === ROLENAME.OperationDesignManager || role.name === ROLENAME.DGM_Design) && designLostApprovalHeader}
                </h3>
            </div>
            <Divider />

            {userDetails?.roles && userDetails.roles.some(role => [ROLENAME.DGM_Sales, ROLENAME.SalesHead].includes(role.name)) && (
                <div style={{ display: 'flex' }}>
                    <FormControl style={{ width: '30%', marginTop: '0.4rem' }}>
                        <Autocomplete
                            multiple
                            value={selectedExperienceCenter}
                            onChange={handleMultipleExpData}
                            options={commonExpCenter}
                            getOptionLabel={(option) => option.name}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Select Exp-Center"
                                    variant="outlined"
                                />
                            )}
                        />
                    </FormControl>
                </div>
            )}

            <Paper style={{ marginTop: 20}}>
                <TableContainer component={Paper}>
                    <Table className={classes.table} stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow style={{ backgroundColor: '#333', color: '#fff' }}>
                                <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold'}}>Sl No.</TableCell>
                                <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold'}}>Customer Name</TableCell>
                                <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold'}}>Project No.</TableCell>
                                <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold'}}>Lead No.</TableCell>
                                {/* {userDetails.roles.find(role => role.name !== ROLENAME.Admin) && (
                                    <>
                                        <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold'}}>CHM Design Kick-off Rejection Remarks</TableCell>
                                    </>
                                )} */}
                                <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold'}}>Lost Reason</TableCell>
                                {/* <TableCell>Lost Request User</TableCell> */}
                                <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold'}}>Assigned To</TableCell>
                                <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold'}}>Lead Value</TableCell>
                                <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold'}}>Refund?</TableCell>
                                <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold'}}>Refund Amount</TableCell>
                                {userDetails.roles.find(role=> role.name === 'Sales Manager') && <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold'}}>Attachment/Recording</TableCell>}
                                <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold'}}>Actions</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {loader ? (
                                <TableRow>
                                    <TableCell colSpan={11} style={{ textAlign: 'center' }}>Loading data, please wait...</TableCell>
                                </TableRow>
                            ) : lostApprovalLeads?.length > 0 ? (
                                        lostApprovalLeads?.sort((a, b) => b?.createdAt?.split('-')?.reverse()?.join()?.localeCompare(a?.createdAt?.split('-')?.reverse()?.join())).map((row, i) => {
                                        return (
                                            <TableRow key={i + 1}>
                                            <TableCell component="th">{(currentPage - 1) * 100 + i + 1}</TableCell>
                                            <TableCell component="th" scope="row"> {row?.customerId?.name} </TableCell>
                                            <TableCell component="th" scope="row"> {row?.erpProjectNo ? row?.erpProjectNo : '-'} </TableCell>
                                            <TableCell component="th">
                                                <Link to={`/project-logs/${row?._id}`} style={{ color: "#000", textDecoration: 'underline' }}>{row?.lead_no || "N/A"}</Link>
                                            </TableCell>
                                            {/* <TableCell component="th">{moment(row?.createdAt).format('DD-MM-YYYY')}</TableCell> */}
                                            {/* {userDetails?.roles?.find(role => role?.name !== ROLENAME?.Admin) && (
                                                <>
                                                    <TableCell component="th">{row?.chmReasonForDesignKickOffRejection || 'NA'}</TableCell>
                                                </>
                                            )} */}

                                            <TableCell component="th">{row?.reasonForLost ? row.reasonForLost : row.salesLostReason}</TableCell>
                                            {/* <TableCell component="th">{row?.lostRaiseUser ? row?.lostRaiseUser : 'NA' }</TableCell> */}
                                            <TableCell component="th">{row?.assignTo ? row?.assignTo?.name : 'NA'}</TableCell>
                                            <TableCell component="th">₹ {commaSeparateAmount(row?.grandTotal) || 'NA'}</TableCell>
                                            <TableCell component="th" style={{textAlign: 'center'}}>{row?.lostRefundRequired ? 'Yes' : 'No'}</TableCell>
                                            <TableCell component="th" style={{ textAlign: 'center' }}>{row?.lostRefundRequired ? `₹ ${commaSeparateAmount(row?.lostRefundAmount)}` : 0}</TableCell>
                                            { userDetails?.roles?.find(role=> role.name === 'Sales Manager')  && 
                                             <TableCell component="th" style={{ textAlign: 'center' }}>
                                                { row?.asmLostAttachment ?
                                                        <DownloadOutlined
                                                            onClick={() => window.open(row?.asmLostAttachment)}
                                                            style={{
                                                                color: "green",
                                                                cursor: "pointer",
                                                                fontWeight: "bold",
                                                                fontSize: '24px',
                                                            }}
                                                        />
                                                    : 'NA'
                                                }
                                                </TableCell>
                                            }
                                            {/* Lost Approval Approved dialog */}
                                            <TableCell component="th" >
                                            <div style={{display:'flex', justifyContent: 'center'}}>
                                                    
                                                    <Button variant="contained" color="primary" style={{ marginRight: '10px', marginBottom: '3px' }} onClick={() => handleApprove(row)}
                                                        disabled={!canUserAct(row)}
                                                    > Approve </Button>
                                                    <Button variant="contained" color="secondary" onClick={() => handleReject(row)}
                                                        disabled={!canUserAct(row)}
                                                    >Reject</Button>
                                                    {!canUserAct(row) &&
                                                        <div>
                                                            <Tooltip title='Approval is pending from the previous stage, please wait for completion.'>
                                                                <InfoIcon
                                                                    style={{ cursor: 'pointer', height: '18px' }}
                                                                />
                                                            </Tooltip>
                                                        </div>
                                                    }
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={11} style={{ textAlign: 'center' }}>No Records Found</TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    component="div"
                    count={total}
                    page={currentPage - 1}
                    onPageChange={(event, newPage) => getAllApprovedLeads(selectedExperienceCenter, newPage + 1, rowsPerPage)}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={(event) => {
                        const newLimit = parseInt(event.target.value, 10);
                        setRowsPerPage(newLimit);
                        getAllApprovedLeads(selectedExperienceCenter, 1, newLimit);
                    }}
                    rowsPerPageOptions={[100, 200, 300, 500]}
                    labelDisplayedRows={({ from, to, count }) => `${from}-${to} of ${count}`}
                    style={{ paddingBottom: 25 }}
                />
                <Dialog open={openDialog} onClose={handleCloseDialog}>
                    <DialogTitle>Enter Remarks</DialogTitle>
                    <DialogContent>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="remarks"
                            label="Remarks"
                            type="text"
                            fullWidth
                            style={{ width: 400 }}
                            value={remarks}
                            onChange={handleRemarksChange}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => handleCloseDialog(row)} color="primary" variant="outlined">
                            Cancel
                        </Button>
                        <Button onClick={(e) => handleRejectWithRemarks(row, 'Rejected')} color="primary" variant="outlined">
                            Reject
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog open={openDialogapprove} onClose={handleCloseDialogApprove}>
                    <DialogTitle>Enter Remarks</DialogTitle>
                    <DialogContent>
                        <FormControl>
                            <TextField
                                autoFocus
                                margin="dense"
                                id="remarks"
                                label="Remarks"
                                type="text"
                                fullWidth
                                style={{ width: 400 }}
                                value={remarks}
                                onChange={handleRemarksChange}
                            />
                            {/* upload lost attachment voice  */}
                            {userDetails.roles.find(role => role.name === 'Assistant Sales Manager') &&
                                <>
                                    <TextField
                                        accept="*"
                                        id="lostAttachment"
                                        type="file"
                                        onChange={handleUploadFile}
                                        style={{ display: 'none' }}
                                    />
                                    <label htmlFor={`lostAttachment`}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            style={{ background: "#716ACA" }}
                                            component="span"
                                        >
                                            Upload Attachement/Recording
                                        </Button>
                                        {isFileUploaded && <CheckCircleIcon style={{ verticalAlign: 'middle', marginLeft: 10, color: "green", fontSize: 30 }} />}
                                    </label>
                                </>
                            }

                            {userDetails.roles.find(role => role.name === 'Sales Manager') && asmApproval === 'Approved' &&
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <Checkbox
                                        checked={isChecked}
                                        onChange={(e) => setIsChecked(e.target.checked)}
                                        color="primary"
                                        label='Attachment/Recording verified by me'
                                    />
                                    <span>Attachment/Recording verified by me</span>
                                </div>
                            }

                        </FormControl>

                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => handleCloseDialogApprove(row)} color="primary" variant="outlined">
                            Cancel
                        </Button>
                        <Button onClick={() => handleApproveWithRemarks(row, 'Approved')}
                            color="primary"
                            variant='outlined'
                            disabled={(userDetails.roles.some(role => role.name === 'Assistant Sales Manager') && !isFileUploaded) || (userDetails.roles.some(role => role.name === 'Sales Manager') && !isChecked && asmApproval)}
                        >
                            Approve
                        </Button>
                    </DialogActions>
                </Dialog>
            </Paper>
        </div>
    )
}

export default connect(null, { setLoading, setSnackInfo })(LostLeadApprovalView)